import React from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Pagination } from 'antd';
import Title from '@/components/Title';
import styles from './DeviceConfig.less';
import Configuration from '../../components/DeviceConfig/DeviceConfigItem';
import CopyModal from '../../components/DeviceConfig/CopyModal';

@inject('deviceConfigStore')
@observer
class DeviceConfig extends React.Component {
  componentDidMount() {
    this.props.deviceConfigStore.loadConfigList(
      this.props.deviceConfigStore.currentPage
    );
  }
  render() {
    const {
      configList,
      listPageTotal,
      currentPage,
      changePage,
      showCopyModal
    } = this.props.deviceConfigStore;
    return (
      <div className={styles.DeviceConfigContainer}>
        <Row className={styles.titleContainer}>
          <Title
            titleText={'配置列表'}
            btn={{
              text: '新建配置',
              func: () => showCopyModal(false),
              state: true
            }}
          />
        </Row>
        {configList.length ? (
          [...configList].map(item => (
            <Configuration key={item.configuration_id} data={item} />
          ))
        ) : (
          <div className={styles.nullContainer}>暂无设备配置</div>
        )}
        <div className={styles.paginContainer}>
          <Pagination
            onChange={changePage}
            current={currentPage}
            total={listPageTotal}
            defaultPageSize={10}
            hideOnSinglePage={true}
          />
        </div>
        <CopyModal />
      </div>
    );
  }
}
export default DeviceConfig;



// WEBPACK FOOTER //
// ./src/pages/DeviceConfig/DeviceConfig.js